var map = {
	"./Icon-link.svg": [
		2406,
		2406
	],
	"./add-project-dark.svg": [
		65879,
		65879
	],
	"./add-project.svg": [
		39219,
		39219
	],
	"./add.svg": [
		18492,
		18492
	],
	"./icon-3-dots.svg": [
		57281,
		57281
	],
	"./icon-Behance.svg": [
		35823,
		35823
	],
	"./icon-DuckDuckGo.svg": [
		78305,
		78305
	],
	"./icon-Invision.svg": [
		85316,
		85316
	],
	"./icon-LinkedIN.svg": [
		76375,
		76375
	],
	"./icon-Pinterest.svg": [
		62460,
		62460
	],
	"./icon-Stripe.svg": [
		46531,
		46531
	],
	"./icon-Vietnam.svg": [
		57114,
		57114
	],
	"./icon-Visa.svg": [
		75414,
		75414
	],
	"./icon-_behance.svg": [
		98988,
		98988
	],
	"./icon-add-circle.svg": [
		74807,
		74807
	],
	"./icon-add-square-fill.svg": [
		42166,
		42166
	],
	"./icon-add-square.svg": [
		13370,
		13370
	],
	"./icon-add.svg": [
		56709,
		56709
	],
	"./icon-adobe-xd-tuts.svg": [
		34886,
		34886
	],
	"./icon-align-left.svg": [
		64926,
		64926
	],
	"./icon-analytics.svg": [
		64041,
		64041
	],
	"./icon-archive-orange.svg": [
		56745,
		56745
	],
	"./icon-arrow-down-black.svg": [
		18770,
		18770
	],
	"./icon-arrow-down-triangle.svg": [
		40834,
		40834
	],
	"./icon-arrow-down.svg": [
		90767,
		90767
	],
	"./icon-arrow-left-long.svg": [
		18907,
		18907
	],
	"./icon-arrow-left.svg": [
		20092,
		20092
	],
	"./icon-arrow-right-2.svg": [
		76897,
		76897
	],
	"./icon-arrow-right-long.svg": [
		57797,
		57797
	],
	"./icon-arrow-right-xxl.svg": [
		25435,
		25435
	],
	"./icon-arrow-right.svg": [
		99416,
		99416
	],
	"./icon-arrow-up-black.svg": [
		77972,
		77972
	],
	"./icon-arrow-up-down.svg": [
		90546,
		90546
	],
	"./icon-arrow-up-long.svg": [
		82379,
		82379
	],
	"./icon-arrow-up.svg": [
		42762,
		42762
	],
	"./icon-auth.svg": [
		49399,
		49399
	],
	"./icon-avi.svg": [
		1705,
		1705
	],
	"./icon-backgroundcolor.svg": [
		97309,
		97309
	],
	"./icon-bag-2.svg": [
		77736,
		77736
	],
	"./icon-bag-happy.svg": [
		69466,
		69466
	],
	"./icon-bar-chart.svg": [
		58685,
		58685
	],
	"./icon-behance-inspiration.svg": [
		58783,
		58783
	],
	"./icon-big-city.svg": [
		4354,
		4354
	],
	"./icon-binance.svg": [
		54130,
		54130
	],
	"./icon-bitcoin-card.svg": [
		85785,
		85785
	],
	"./icon-bitcoin.svg": [
		69692,
		69692
	],
	"./icon-blogger.svg": [
		89592,
		89592
	],
	"./icon-bnb.svg": [
		88710,
		88710
	],
	"./icon-bold.svg": [
		72534,
		72534
	],
	"./icon-bookmark.svg": [
		3289,
		3289
	],
	"./icon-bootstrap.svg": [
		1822,
		1822
	],
	"./icon-brasil.svg": [
		65118,
		65118
	],
	"./icon-briefcase.svg": [
		86081,
		86081
	],
	"./icon-brush.svg": [
		91319,
		91319
	],
	"./icon-calendar-1.svg": [
		55674,
		55674
	],
	"./icon-calendar-2.svg": [
		53613,
		53613
	],
	"./icon-calendar-3.svg": [
		41130,
		41130
	],
	"./icon-calendar.svg": [
		85591,
		85591
	],
	"./icon-cardano.svg": [
		37936,
		37936
	],
	"./icon-caret-down.svg": [
		71180,
		71180
	],
	"./icon-cart.svg": [
		89393,
		89393
	],
	"./icon-chart-2.svg": [
		76607,
		76607
	],
	"./icon-chart.svg": [
		47472,
		47472
	],
	"./icon-chat-bubble-dark.svg": [
		39257,
		39257
	],
	"./icon-chat-bubble.svg": [
		24437,
		24437
	],
	"./icon-chat.svg": [
		33912,
		33912
	],
	"./icon-check-circle.svg": [
		32672,
		32672
	],
	"./icon-clients.svg": [
		93182,
		93182
	],
	"./icon-clock.svg": [
		21687,
		21687
	],
	"./icon-close-circle.svg": [
		53657,
		53657
	],
	"./icon-close-modal.svg": [
		28382,
		28382
	],
	"./icon-close-square.svg": [
		60899,
		60899
	],
	"./icon-close.svg": [
		79566,
		79566
	],
	"./icon-cms.svg": [
		72332,
		72332
	],
	"./icon-code-pink.svg": [
		26637,
		26637
	],
	"./icon-code-violet.svg": [
		34091,
		34091
	],
	"./icon-code.svg": [
		96157,
		96157
	],
	"./icon-color-swatch.svg": [
		52676,
		52676
	],
	"./icon-copy-2.svg": [
		11052,
		11052
	],
	"./icon-copy.svg": [
		74714,
		74714
	],
	"./icon-course.svg": [
		30261,
		30261
	],
	"./icon-crm.svg": [
		53428,
		53428
	],
	"./icon-crypto.svg": [
		68540,
		68540
	],
	"./icon-css.svg": [
		99908,
		99908
	],
	"./icon-dashboard.svg": [
		46905,
		46905
	],
	"./icon-date.svg": [
		73287,
		73287
	],
	"./icon-design.svg": [
		30787,
		30787
	],
	"./icon-direct-right.svg": [
		48906,
		48906
	],
	"./icon-directbox-default.svg": [
		77641,
		77641
	],
	"./icon-doc.svg": [
		95700,
		95700
	],
	"./icon-done.svg": [
		94876,
		94876
	],
	"./icon-down-white.svg": [
		24924,
		24924
	],
	"./icon-down.svg": [
		61842,
		61842
	],
	"./icon-dribbble-community.svg": [
		94225,
		94225
	],
	"./icon-dribbble.svg": [
		51377,
		51377
	],
	"./icon-economy.svg": [
		45500,
		45500
	],
	"./icon-edit-2.svg": [
		82075,
		82075
	],
	"./icon-edit.svg": [
		30010,
		30010
	],
	"./icon-element-3.svg": [
		87853,
		87853
	],
	"./icon-email.svg": [
		11529,
		11529
	],
	"./icon-ethereum.svg": [
		94592,
		94592
	],
	"./icon-export-green.svg": [
		17611,
		17611
	],
	"./icon-export-red.svg": [
		63608,
		63608
	],
	"./icon-export.svg": [
		36457,
		36457
	],
	"./icon-eye.svg": [
		16699,
		16699
	],
	"./icon-facebook-2.svg": [
		43811,
		43811
	],
	"./icon-facebook.svg": [
		73061,
		73061
	],
	"./icon-favicon.svg": [
		25602,
		25602
	],
	"./icon-favorite-chart.svg": [
		41489,
		41489
	],
	"./icon-figma-resources.svg": [
		6855,
		6855
	],
	"./icon-file-pdf.svg": [
		83017,
		83017
	],
	"./icon-file.svg": [
		95832,
		95832
	],
	"./icon-fill-share.svg": [
		96345,
		96345
	],
	"./icon-filter-2-black.svg": [
		71405,
		71405
	],
	"./icon-filter-2.svg": [
		47480,
		47480
	],
	"./icon-filter.svg": [
		62120,
		62120
	],
	"./icon-flag.svg": [
		46403,
		46403
	],
	"./icon-flash.svg": [
		9232,
		9232
	],
	"./icon-folder-2.svg": [
		13744,
		13744
	],
	"./icon-folder-open.svg": [
		37815,
		37815
	],
	"./icon-folder.svg": [
		96156,
		96156
	],
	"./icon-france.svg": [
		97489,
		97489
	],
	"./icon-gallery-favorite.svg": [
		39924,
		39924
	],
	"./icon-gallery-fill.svg": [
		52077,
		52077
	],
	"./icon-gallery.svg": [
		52098,
		52098
	],
	"./icon-gif-boxy.svg": [
		61927,
		61927
	],
	"./icon-gif.svg": [
		57434,
		57434
	],
	"./icon-google+.svg": [
		46667,
		46667
	],
	"./icon-google.svg": [
		40274,
		40274
	],
	"./icon-graph.svg": [
		87790,
		87790
	],
	"./icon-grid.svg": [
		48933,
		48933
	],
	"./icon-hashtag.svg": [
		37054,
		37054
	],
	"./icon-headphone.svg": [
		3995,
		3995
	],
	"./icon-home-2.svg": [
		11801,
		11801
	],
	"./icon-home-hashtag.svg": [
		97410,
		97410
	],
	"./icon-image-purple.svg": [
		26138,
		26138
	],
	"./icon-image.svg": [
		77325,
		77325
	],
	"./icon-inbox.svg": [
		93114,
		93114
	],
	"./icon-indent.svg": [
		33056,
		33056
	],
	"./icon-india.svg": [
		56268,
		56268
	],
	"./icon-input-phone.svg": [
		22065,
		22065
	],
	"./icon-input-user.svg": [
		56630,
		70420
	],
	"./icon-insert-file.svg": [
		47263,
		47263
	],
	"./icon-insert-image.svg": [
		4854,
		4854
	],
	"./icon-insert-link.svg": [
		92429,
		92429
	],
	"./icon-insert-video.svg": [
		1321,
		1321
	],
	"./icon-instagram-2.svg": [
		66905,
		66905
	],
	"./icon-italicized.svg": [
		3931,
		3931
	],
	"./icon-job.svg": [
		4476,
		4476
	],
	"./icon-jpg.svg": [
		35555,
		35555
	],
	"./icon-landing-reset-password.svg": [
		15680,
		15680
	],
	"./icon-landing-success-1.svg": [
		49170,
		49170
	],
	"./icon-layer.svg": [
		23522,
		23522
	],
	"./icon-lightning.svg": [
		80164,
		80164
	],
	"./icon-like-linear.svg": [
		47087,
		47087
	],
	"./icon-like.svg": [
		51741,
		53120
	],
	"./icon-linkedin-2.svg": [
		15816,
		15816
	],
	"./icon-location.svg": [
		15702,
		15702
	],
	"./icon-logo.svg": [
		46636,
		46636
	],
	"./icon-logout.svg": [
		33770,
		33770
	],
	"./icon-magento2.svg": [
		10309,
		10309
	],
	"./icon-mailbox-user.svg": [
		87984,
		87984
	],
	"./icon-mailbox.svg": [
		55196,
		55196
	],
	"./icon-master-card.svg": [
		20829,
		20829
	],
	"./icon-maximize-3.svg": [
		59748,
		59748
	],
	"./icon-medal-star.svg": [
		42775,
		42775
	],
	"./icon-menu.svg": [
		96337,
		96337
	],
	"./icon-message-edit.svg": [
		90097,
		90097
	],
	"./icon-message.svg": [
		60041,
		60041
	],
	"./icon-messages-2.svg": [
		64995,
		64995
	],
	"./icon-messages-3.svg": [
		7479,
		7479
	],
	"./icon-messages.svg": [
		60146,
		60146
	],
	"./icon-microphone-2.svg": [
		44468,
		44468
	],
	"./icon-mkv.svg": [
		89630,
		89630
	],
	"./icon-money.svg": [
		30690,
		30690
	],
	"./icon-moon-active.svg": [
		33392,
		33392
	],
	"./icon-moon.svg": [
		66943,
		66943
	],
	"./icon-more.svg": [
		20035,
		20035
	],
	"./icon-movie-red.svg": [
		52236,
		52236
	],
	"./icon-movie-skype.svg": [
		98941,
		98941
	],
	"./icon-mp3.svg": [
		93025,
		93025
	],
	"./icon-music-pink.svg": [
		27617,
		27617
	],
	"./icon-music-square.svg": [
		81059,
		81059
	],
	"./icon-network.svg": [
		11550,
		11550
	],
	"./icon-no.svg": [
		88810,
		88810
	],
	"./icon-note-green.svg": [
		72857,
		72857
	],
	"./icon-notification-bing.svg": [
		85522,
		85522
	],
	"./icon-ok.svg": [
		91218,
		91218
	],
	"./icon-ordered-list.svg": [
		76565,
		76565
	],
	"./icon-orders.svg": [
		94821,
		94821
	],
	"./icon-paper-clip.svg": [
		31341,
		31341
	],
	"./icon-paragraphformat.svg": [
		80194,
		80194
	],
	"./icon-password-required.svg": [
		4239,
		4239
	],
	"./icon-payments.svg": [
		12274,
		12274
	],
	"./icon-pdf.svg": [
		93148,
		93148
	],
	"./icon-pencil.svg": [
		97612,
		97612
	],
	"./icon-people.svg": [
		3484,
		3484
	],
	"./icon-picture-boxy.svg": [
		76328,
		76328
	],
	"./icon-plus.svg": [
		52277,
		52277
	],
	"./icon-print.svg": [
		3905,
		3905
	],
	"./icon-printer.svg": [
		26215,
		26215
	],
	"./icon-products.svg": [
		51749,
		51749
	],
	"./icon-profile-2user.svg": [
		30347,
		30347
	],
	"./icon-programming-arrows.svg": [
		85778,
		85778
	],
	"./icon-progress.svg": [
		93275,
		93275
	],
	"./icon-project.svg": [
		53629,
		53629
	],
	"./icon-psd.svg": [
		31079,
		31079
	],
	"./icon-pug.svg": [
		73844,
		73844
	],
	"./icon-question-mark.svg": [
		1807,
		1807
	],
	"./icon-react.svg": [
		81358,
		81358
	],
	"./icon-redo.svg": [
		26334,
		26334
	],
	"./icon-redux.svg": [
		54730,
		54730
	],
	"./icon-refresh.svg": [
		39797,
		39797
	],
	"./icon-refunds.svg": [
		85576,
		85576
	],
	"./icon-retrack.svg": [
		27609,
		27609
	],
	"./icon-row-vertical.svg": [
		99588,
		99588
	],
	"./icon-sass.svg": [
		49907,
		49907
	],
	"./icon-search-normal.svg": [
		34232,
		34232
	],
	"./icon-send-1.svg": [
		80187,
		80187
	],
	"./icon-send-2.svg": [
		72278,
		72278
	],
	"./icon-setting-2.svg": [
		3425,
		3425
	],
	"./icon-setting.svg": [
		38312,
		38312
	],
	"./icon-shapes.svg": [
		79502,
		79502
	],
	"./icon-share.svg": [
		3787,
		3787
	],
	"./icon-shield-check.svg": [
		43786,
		43786
	],
	"./icon-shield-tick-circle.svg": [
		87713,
		87713
	],
	"./icon-shield-tick.svg": [
		94869,
		94869
	],
	"./icon-sketch-app-tuts.svg": [
		84588,
		84588
	],
	"./icon-smile-boxy.svg": [
		41332,
		41332
	],
	"./icon-smile.svg": [
		27885,
		27885
	],
	"./icon-sms.svg": [
		48738,
		48738
	],
	"./icon-snooze.svg": [
		36704,
		36704
	],
	"./icon-social.svg": [
		15112,
		15112
	],
	"./icon-star-2.svg": [
		70469,
		70469
	],
	"./icon-star-yellow.svg": [
		10624,
		10624
	],
	"./icon-star.svg": [
		66132,
		66132
	],
	"./icon-starred.svg": [
		57690,
		57690
	],
	"./icon-strikethrough.svg": [
		3280,
		3280
	],
	"./icon-subtitle.svg": [
		17466,
		17466
	],
	"./icon-sun-active.svg": [
		83299,
		83299
	],
	"./icon-sun.svg": [
		1667,
		1667
	],
	"./icon-svg.svg": [
		67015,
		67015
	],
	"./icon-sweden.svg": [
		89081,
		89081
	],
	"./icon-tailwind.svg": [
		94890,
		94890
	],
	"./icon-tether.svg": [
		16878,
		16878
	],
	"./icon-textcolor.svg": [
		10425,
		10425
	],
	"./icon-themeforest-market.svg": [
		87276,
		87276
	],
	"./icon-thunder.svg": [
		37166,
		37166
	],
	"./icon-tick-circle.svg": [
		444,
		444
	],
	"./icon-tick-square.svg": [
		72546,
		72546
	],
	"./icon-toggle-horizontal.svg": [
		30009,
		30009
	],
	"./icon-toggle.svg": [
		58511,
		58511
	],
	"./icon-trade.svg": [
		38579,
		38579
	],
	"./icon-transactions.svg": [
		84950,
		84950
	],
	"./icon-transport.svg": [
		53082,
		53082
	],
	"./icon-trash.svg": [
		99010,
		99010
	],
	"./icon-tree.svg": [
		16630,
		16630
	],
	"./icon-trx.svg": [
		93801,
		93801
	],
	"./icon-turkey.svg": [
		36681,
		36681
	],
	"./icon-twitter-2.svg": [
		81231,
		81231
	],
	"./icon-twitter.svg": [
		74716,
		74716
	],
	"./icon-txt.svg": [
		61794,
		61794
	],
	"./icon-underlined.svg": [
		96398,
		96398
	],
	"./icon-undo.svg": [
		9441,
		9441
	],
	"./icon-uni.svg": [
		93715,
		93715
	],
	"./icon-united-states.svg": [
		50917,
		50917
	],
	"./icon-unordered-list.svg": [
		94825,
		94825
	],
	"./icon-update.svg": [
		7458,
		7458
	],
	"./icon-usd.svg": [
		19337,
		19337
	],
	"./icon-usdc.svg": [
		47295,
		47295
	],
	"./icon-user-square.svg": [
		12856,
		12856
	],
	"./icon-user.svg": [
		66134,
		66134
	],
	"./icon-verify.svg": [
		91632,
		91632
	],
	"./icon-video-camera-boxy.svg": [
		8251,
		8251
	],
	"./icon-video-gradient.svg": [
		25601,
		25601
	],
	"./icon-video-square.svg": [
		28129,
		28129
	],
	"./icon-video.svg": [
		31997,
		31997
	],
	"./icon-wallet.svg": [
		62415,
		62415
	],
	"./icon-webpack.svg": [
		53451,
		53451
	],
	"./icon-white-ui-store.svg": [
		14160,
		14160
	],
	"./icon-work.svg": [
		50216,
		50216
	],
	"./icon-x.svg": [
		17799,
		17799
	],
	"./icon-xls.svg": [
		54643,
		54643
	],
	"./icon-xrp.svg": [
		79555,
		79555
	],
	"./icon-zip.svg": [
		32812,
		32812
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 87328;
module.exports = webpackAsyncContext;